import React, { Component } from "react";
import { FormField } from "react-form";
import MuiCheckbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import { withStyles } from "@material-ui/core";

const styles = {
  error: { color: "#c62828" },
  disabledLabel: {
    color: 'rgba(0, 0, 0, 0.65) !important',
  },
};

class CheckboxWrapper extends Component {
  handleChange = (event) => {
    const { fieldApi, eventHandle } = this.props;
    const { setValue, setTouched } = fieldApi;

    setValue(event.target.checked);
    setTouched();

    if (eventHandle) eventHandle(event.target.checked, this);
  };

  render() {
    const { fieldApi, label, align, classes, color, st, disabled, required, ...rest } = this.props;
    const { getValue, getError, getWarning } = fieldApi;

    const value = Boolean(getValue());
    const error = getError();
    const warning = getWarning();
    const hasError = !!(error || warning);

    const style = st ? { display: "inline-block", width: 210, marginTop: 10, marginLeft: 8 } : undefined;

    return (
      <div
        className={align}
        style={{
          ...style,
          ...(disabled && { backgroundColor: '#f5f5f5', padding: '8px', borderRadius: '4px', pointerEvents: 'none' }),
        }}
      >
        <FormControlLabel
          control={
            <MuiCheckbox
              disabled={disabled}
              color={color || "primary"}
              checked={value}
              onChange={this.handleChange}
              required={required}
              {...rest}
            />
          }
          label={label}
          style={{ marginRight: -4 }}
          classes={{ label: hasError ? classes.error : disabled ? classes.disabledLabel : "" }}
        />

        {required && <FormHelperText style={{ marginTop: 0 }}>Required</FormHelperText>}
        {rest.children}

        {hasError && (
          <FormHelperText className={align} style={{ color: "#c62828" }}>
            {error || warning}
          </FormHelperText>
        )}
      </div>
    );
  }
}

CheckboxWrapper.displayName = "accCheckboxWrapper";
const AccCheckbox = FormField(CheckboxWrapper);

export default withStyles(styles)(AccCheckbox);
